import { memo, useEffect, useState } from 'react'
import { loadSketchThumbnail } from '@/lib/canvas/shader/library'
import { cn } from '@/lib/utils'

interface SketchThumbnailProps {
  sketchId: string
  className?: string
}

/** Rendered preview of a library sketch; renders nothing until (or unless) one loads. */
export const SketchThumbnail = memo(function SketchThumbnail({ sketchId, className }: SketchThumbnailProps) {
  const [src, setSrc] = useState<string>()

  useEffect(() => {
    let cancelled = false
    setSrc(undefined)
    void loadSketchThumbnail(sketchId)?.then((url) => { if (!cancelled) setSrc(url) })
    return () => { cancelled = true }
  }, [sketchId])

  if (!src) return null
  return (
    <img
      src={src}
      alt=""
      draggable={false}
      loading="lazy"
      className={cn('absolute inset-0 h-full w-full object-cover', className)}
    />
  )
})
